const SPECIAL_ADDRESS_LABELS = {
  account_rdx12y7up9wwuvrlp4upvlgt9ka222p6u9dnqfa0ldygcn7qatl9e6k0za:
    "Piers",
  account_rdx16y28dextdn0sleutgylq4dde08vd83zhhkwaxp0ygzldpdms5u08an:
    "Trump",
  account_rdx168w3g79ea7yh6ge07y4zkd8vgmxsyaelhvyk4ngye5p5use69mzag2:
    "Adam",
  account_rdx12xa75arlle03cquxrh37wnvpavfyhu7qxnu96q2jj8p0ytdjy24wkr:
    "Rick",
  account_rdx128yzt39m9a47lx3r8zc2xdyc8rquh56qyrke7a0lsxg9u6dppzc2rv:
    "Sasha Slapworthy",
  account_rdx168y70j69fz78xjy7tdwcka9vfsprnpu6leep92vv7cmmwv3s4vyh6g:
    "Logan Paul",
  account_rdx169zfqf8x47pdasuc3zu7dk0r6a227jlnkg4smzrre4lrmhusk7xslu:
    "Big Red Dick",
  account_rdx168plahkyz4s3etc80wapa2n2w5jd506zmv330t24v6hhhrkeehcu2d:
    "Calablack",
};

const toNumber = (value) => {
  if (typeof value === "number" && Number.isFinite(value)) {
    return value;
  }

  if (typeof value === "string" && value.trim()) {
    const parsed = Number.parseFloat(value);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  return 0;
};

const getDefaultSortColumn = (tab) => {
  if (tab === "dckslap") return "mints";
  if (tab === "gbof") return "mintsMonth";
  if (tab === "received") return "received";
  if (tab === "sent") return "sentMonth";
  return "mints";
};

const sortEntries = (entries, { tab, sortColumn, sortDirection }) => {
  const column = sortColumn || getDefaultSortColumn(tab);
  const direction = sortDirection === "asc" ? 1 : -1;

  const sorted = [...entries].sort((left, right) => {
    const leftValue = toNumber(left[column]);
    const rightValue = toNumber(right[column]);
    if (leftValue === rightValue) {
      return left.address.localeCompare(right.address);
    }

    return (leftValue - rightValue) * direction;
  });

  return sorted.map((entry, index) => ({
    ...entry,
    rank: index + 1,
  }));
};

const processMintAndTransferData = (data, gbofMintedMonthData = {}) => {
  const entriesByAddress = new Map();

  (Array.isArray(data?.transfers) ? data.transfers : []).forEach((transfer) => {
    const accounts = transfer?.accountsReceived || transfer?.accounts;
    if (!accounts || typeof accounts !== "object") {
      return;
    }

    Object.entries(accounts).forEach(([address, amount]) => {
      const existing = entriesByAddress.get(address) || {
        address,
        transfers: 0,
        mints: 0,
        mintsMonth: gbofMintedMonthData[address] || 0,
      };
      existing.transfers += toNumber(amount);
      entriesByAddress.set(address, existing);
    });
  });

  (Array.isArray(data?.mints) ? data.mints : []).forEach((mint) => {
    if (!mint?.accounts || typeof mint.accounts !== "object") {
      return;
    }

    Object.entries(mint.accounts).forEach(([address, amount]) => {
      const existing = entriesByAddress.get(address) || {
        address,
        transfers: 0,
        mints: 0,
        mintsMonth: gbofMintedMonthData[address] || 0,
      };
      existing.mints += toNumber(amount);
      existing.mintsMonth = gbofMintedMonthData[address] || 0;
      entriesByAddress.set(address, existing);
    });
  });

  return [...entriesByAddress.values()];
};

const processReceivedData = (data) => {
  const entriesByAddress = new Map();

  (Array.isArray(data?.transfers) ? data.transfers : []).forEach((transfer) => {
    if (!transfer?.accountsReceived || typeof transfer.accountsReceived !== "object") {
      return;
    }

    Object.entries(transfer.accountsReceived).forEach(([address, amount]) => {
      const existing = entriesByAddress.get(address) || { address, received: 0 };
      existing.received += toNumber(amount);
      entriesByAddress.set(address, existing);
    });
  });

  return [...entriesByAddress.values()];
};

const processSentData = (data, slapSentData = {}) => {
  const entriesByAddress = new Map();

  (Array.isArray(data?.transfers) ? data.transfers : []).forEach((transfer) => {
    if (!transfer?.accountsSent || typeof transfer.accountsSent !== "object") {
      return;
    }

    Object.entries(transfer.accountsSent).forEach(([address, amount]) => {
      const existing = entriesByAddress.get(address) || {
        address,
        sent: 0,
        sentMonth: slapSentData[address] || 0,
      };
      existing.sent += toNumber(amount);
      existing.sentMonth = slapSentData[address] || 0;
      entriesByAddress.set(address, existing);
    });
  });

  return [...entriesByAddress.values()];
};

export const buildLeaderboardRows = ({
  activeTab,
  dckslapData,
  gbofData,
  gbofMintedMonthData,
  slapSentData,
  sortColumn,
  sortDirection,
}) => {
  const tab = activeTab || "dckslap";

  const rawEntries =
    tab === "received"
      ? processReceivedData(dckslapData)
      : tab === "sent"
        ? processSentData(dckslapData, slapSentData)
        : processMintAndTransferData(
            tab === "dckslap" ? dckslapData : gbofData,
            gbofMintedMonthData,
          );

  return sortEntries(rawEntries, { tab, sortColumn, sortDirection });
};

export const getTabColumns = (activeTab, currentMonthName) => {
  if (activeTab === "received") {
    return [{ key: "received", label: "Received" }];
  }

  if (activeTab === "sent") {
    return [
      { key: "sent", label: "All Time" },
      { key: "sentMonth", label: currentMonthName },
    ];
  }

  if (activeTab === "gbof") {
    return [
      { key: "transfers", label: "Transferred" },
      { key: "mints", label: "Total Minted" },
      { key: "mintsMonth", label: currentMonthName },
    ];
  }

  return [
    { key: "transfers", label: "Received" },
    { key: "mints", label: "Minted" },
  ];
};

export const getTabDisplayName = (activeTab) => {
  if (activeTab === "received") return "Received";
  if (activeTab === "sent") return "Sent";
  if (activeTab === "gbof") return "GBOF";
  return "DCKSLAP";
};

export const truncateWallet = (address) => {
  if (!address || typeof address !== "string") {
    return "Unknown";
  }

  return `${address.slice(0, 10)}...${address.slice(-6)}`;
};

export const getSpecialLabel = (address) => SPECIAL_ADDRESS_LABELS[address] || null;

